import { IconButton, SvgIcon, Tooltip } from "@mui/material";
import { useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { AvatarCell } from "pages/School/TestTakers";
import { ImageCell } from "components/Table";
import AffiliationLabel from "../AffiliationLabel";

const useColumns = () => {
    const navigate = useNavigate()

    const goAffiliation = useCallback((id) => {
        navigate(`${app.affiliations}/${id}`)
    }, [])

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: "ID",
                fetaute: "col_ID",
                role: "read"
            },
            {
                accessorKey: 'logo',
                width: 30,
                header: "",
                cell: ImageCell
            },
            {
                accessorKey: 'name',
                header: "שם הבית ספר",
                cell: (info) => <AffiliationLabel name={info.getValue()} display_name={info.row.original.display_name} city={info.row.original.city} />
            },
            {
                accessorKey: 'city.label',
                header: "עיר",
            },
            {
                accessorKey: 'enter_audio_cutting',
                header: "פרטי בית ספר",
                enableSorting: false,
                cell: ({ row }) => {

                    return (
                        <Tooltip key={row.original.id} tooltip="לכניסה" placement="left">
                            <IconButton
                                className="transparent-icon"
                                onClick={() => {
                                    goAffiliation(row.original.id)
                                }}
                            >
                                <SvgIcon component={GoIcon} inheritViewBox />
                            </IconButton>
                        </Tooltip>
                    );
                }
            },
        ], []
    )

    return columns
}

export default useColumns